var map = {
	"./GAN.png": 728,
	"./IMG-20241104-WA0004.jpg": 635,
	"./NoteCraft.png": 392,
	"./ResuMaster.jpg": 269,
	"./Site.png": 401,
	"./SnapShop.png": 472,
	"./balance.png": 946,
	"./goldp.png": 744,
	"./icons8-github-64.png": 921,
	"./image1.jpg": 172,
	"./logo1.png": 424,
	"./readme_icon.png": 448
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 263;